import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
function GetUrlParam(paraName) {//截取token
  // return paraName.slice(paraName.indexOf("=")+1,paraName.indexOf("&"))
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] === paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}
// axios.defaults.baseURL = 'https://api-dev.lejian.net'
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (GetUrlParam("t")) {
      config.headers = {
        'Content-Type': 'application/json',
        'access-token': '',
        'token': GetUrlParam('t'),
        'Authorization': '',
      }
    } else {
      config.headers = {
        'Content-Type': 'application/json',
        'access-token': '',
        'Authorization': '',
      }
    }

    let tokenId = localStorage.getItem("TOKEN");
    let lang = localStorage.getItem('lang');
    if (tokenId) {
      config.headers['access-token'] = tokenId;
      config.headers['Authorization'] = 'JWT ' + tokenId;
    }
    if (lang) {
      config.headers['Accept-Language'] = lang;
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.log(error.response)
    if (error.response.data.data == undefined) {
      if (error.response.data.status_code == 401) {
        sessionStorage.clear();
        localStorage.clear();
        this.$store.dispatch('quitUser');
        window.location.href = '/';
      } else if (error.response.data.status_code == 403) {
        Message({
          message: error.response.data.detail,
          type: 'error',
          center: true,
          duration: 5000
        })
      } else if (error.response.data.status_code == 400) {
        Message({
          message: error.response.data.detail,
          type: 'error',
          center: true,
          duration: 5000
        })
      } else if (error.response.data.status_code == 404) {
        Message({
          message: error.response.data.detail,
          type: 'error',
          center: true,
          duration: 5000
        })
      } else {
        if (error.response.data.return_code === 99999) {
          sessionStorage.clear();
          localStorage.clear();
          this.$store.dispatch('quitUser');
          window.location.href = '/';
        }
        Message({
          message: error.response.data.return_msg,
          type: 'error',
          center: true,
          duration: 5000
        })
      }

    } else {
      Message({
        message: error.response.data.data.gender[0],
        type: 'error',
        center: true,
        duration: 5000
      })
    }
    return Promise.reject(error)
  })


//get请求
export const GET = (url, param) => {
  if (param) {
    return axios.get(url, {
      params: param
    })
  } else {
    return axios.get(url)
  }
}
//post请求
export const POST = (url, param, config) => {
  if (config) {
    return axios.post(url, param, config)
  } else {
    return axios.post(url, param)
  }
}

export const PUT = (url, param) => {
  return axios.put(url, param)
}

export const DELETE = (url) => {
  return axios.delete(url)
}



// WEBPACK FOOTER //
// ./src/utils/http.js